import { BaseViewModel } from "app/based/baseViewModel/BaseViewModel";
import { SimLookupInjection } from "features/simStatusLookup/di/SimLookupInjection";
import { SimLookupRequestEntity } from "features/simStatusLookup/domain/entities/SimLookupRequestEntity";
import { SimLookupResponseEntity } from "features/simStatusLookup/domain/entities/SimLookupResponseEntity";
import { BehaviorSubject } from "rxjs";
import { injectable } from "tsyringe";
import { strings } from "utils/localizedStrings";

// ─── Input ────────────────────────────────────────────────────────────────────

class SimLookupInput implements Disposable {
  public fetchSupportFeature = new BehaviorSubject<SimLookupRequestEntity>(undefined);

  [Symbol.dispose](): void {
    this.fetchSupportFeature.complete();
  }
}

// ─── Output ───────────────────────────────────────────────────────────────────

class SimLookupOutput implements Disposable {
  public savedLookupData = new BehaviorSubject<SimLookupResponseEntity>(undefined);
  public onError = new BehaviorSubject<string>("");
  public loading = new BehaviorSubject<boolean>(false);

  [Symbol.dispose](): void {
    this.savedLookupData.complete();
    this.onError.complete();
    this.loading.complete();
  }
}

// ─── ViewModel ────────────────────────────────────────────────────────────────

@injectable()
export class SimLookupViewModel extends BaseViewModel<
  SimLookupInput,
  SimLookupOutput
> {
  constructor() {
    super(new SimLookupInput(), new SimLookupOutput());
  }

  private useCase = SimLookupInjection.getUseCase();

  protected override transform(): void {
    this.skipFirstInitial(this.input.fetchSupportFeature, async (params) => {
      try {
        this.output.loading.next(true);
        const res = await this.useCase.viewSim(params);
        if (res?.data) {
          this.output.savedLookupData.next(res?.data);
        }
      } catch (error) {
        console.error(error);
        this.output.onError.next(error?.message || strings.GlobalMessage.Error);
      } finally {
        this.output.loading.next(false);
      }
    });
  }
}